import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/inherits";
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
import PropTypes from 'prop-types';
import React from 'react';
import _ from 'lodash';
import classNames from 'classnames';
import compose from '../../hoc/compose';
import displayNames from '../displayNames';
import BaseModal from '../baseModal/baseModal';
import Text from '../text/text';
import Heading from '../heading/heading';
import { dataHooks } from './constants';
var THEMES = ['standard', 'destructive', 'premium'];
var MessageModal = /*#__PURE__*/function (_React$PureComponent) {
  function MessageModal() {
    _classCallCheck(this, MessageModal);
    return _callSuper(this, MessageModal, arguments);
  }
  _inherits(MessageModal, _React$PureComponent);
  return _createClass(MessageModal, [{
    key: "_renderContent",
    value: function _renderContent() {
      var _this$props = this.props,
        title = _this$props.title,
        content = _this$props.content,
        illustration = _this$props.illustration;
      return /*#__PURE__*/React.createElement(React.Fragment, null, illustration && /*#__PURE__*/React.createElement(React.Fragment, null, _.isString(illustration) ? /*#__PURE__*/React.createElement("img", {
        className: "control-message-modal-image",
        "data-hook": dataHooks.illustrationSrc,
        src: illustration
      }) : /*#__PURE__*/React.createElement("div", {
        className: "control-message-modal-illustration",
        "data-hook": dataHooks.illustration
      }, illustration)), /*#__PURE__*/React.createElement("div", {
        className: "control-message-modal-content-wrapper"
      }, title && /*#__PURE__*/React.createElement("div", {
        className: "control-message-modal-title"
      }, /*#__PURE__*/React.createElement(Heading, {
        dataHook: dataHooks.title,
        appearance: "h2",
        multiline: true,
        shouldTranslate: false
      }, title)), content && /*#__PURE__*/React.createElement("div", {
        className: "control-message-modal-content",
        "data-hook": dataHooks.content
      }, _.isString(content) ? /*#__PURE__*/React.createElement(Text, {
        dataHook: dataHooks.contentText,
        size: "medium",
        weight: "normal",
        skin: "secondary",
        enableEllipsis: false,
        shouldTranslate: false
      }, content) : content)));
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props2 = this.props,
        dataHook = _this$props2.dataHook,
        getClassName = _this$props2.getClassName,
        theme = _this$props2.theme,
        illustration = _this$props2.illustration,
        sideActions = _this$props2.sideActions,
        footnote = _this$props2.footnote,
        onCloseButtonClick = _this$props2.onCloseButtonClick,
        onHelpButtonClick = _this$props2.onHelpButtonClick,
        primaryButtonText = _this$props2.primaryButtonText,
        primaryButtonProps = _this$props2.primaryButtonProps,
        primaryButtonOnClick = _this$props2.primaryButtonOnClick,
        secondaryButtonText = _this$props2.secondaryButtonText,
        secondaryButtonProps = _this$props2.secondaryButtonProps,
        secondaryButtonOnClick = _this$props2.secondaryButtonOnClick;
      return /*#__PURE__*/React.createElement(BaseModal, {
        dataHook: dataHook,
        theme: theme,
        sideActions: sideActions,
        footnote: footnote,
        onCloseButtonClick: onCloseButtonClick,
        onHelpButtonClick: onHelpButtonClick,
        primaryButtonText: primaryButtonText,
        primaryButtonProps: primaryButtonProps,
        primaryButtonOnClick: primaryButtonOnClick,
        secondaryButtonText: secondaryButtonText,
        secondaryButtonProps: secondaryButtonProps,
        secondaryButtonOnClick: secondaryButtonOnClick,
        className: getClassName(classNames('control-message-modal', {
          'with-illustration': illustration
        }))
      }, this._renderContent());
    }
  }]);
}(React.PureComponent);
MessageModal.displayName = displayNames.MESSAGE_MODAL;
MessageModal.propTypes = {
  /** Applies a data-hook HTML attribute that can be used in the tests */
  dataHook: PropTypes.string,
  /** A css class to be applied to the component's root element */
  className: PropTypes.string,
  /** A global theme for the modal */
  theme: PropTypes.oneOf(THEMES),
  /** The modal's title */
  title: PropTypes.string.isRequired,
  /** The content of the MessageModal */
  content: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
  /** The illustration src or the illustration node itself */
  illustration: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
  /** side actions node, to be rendered as the first element on the same row as the action buttons */
  sideActions: PropTypes.node,
  /** a footnote node, to be rendered at the very bottom of the modal */
  footnote: PropTypes.node,
  /** callback for when the close button is clicked */
  onCloseButtonClick: PropTypes.func,
  /** callback for when the help button is clicked */
  onHelpButtonClick: PropTypes.func,
  /** a text for the primary action button */
  primaryButtonText: PropTypes.string.isRequired,
  /** Passed to the primary action button as props without any filter / mutation */
  primaryButtonProps: PropTypes.object,
  /** callback for when the secondary action button is clicked */
  primaryButtonOnClick: PropTypes.func.isRequired,
  /** a text for the secondary action button */
  secondaryButtonText: PropTypes.string,
  /**
   * Passed to the secondary button as props without any filter / mutation
   * @linkTypeTo controls--button
   * @setTypeName ButtonProps
   */
  secondaryButtonProps: PropTypes.object,
  /** callback for when the secondary action button is clicked */
  secondaryButtonOnClick: PropTypes.func
};
MessageModal.defaultProps = {
  dataHook: 'MessageModal',
  theme: 'standard'
};
export default compose(MessageModal);